import React, { useEffect, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useNavigate, useParams } from "react-router-dom";
import { FerramentasDeDetalhe } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    Box, Button, Icon,
    Paper, Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    useTheme

} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { FranquiaService, IDetalheFranquia, ILstDrop, ILstDropAtivosProposta } from "../../shered/services/api/franquia/FranquiaService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { Loading } from "../../shered/components/loading/Loading";
import { UtilidadeService, lstTiposAtivos } from "../../shered/services/api/utilidades/UtilidadesService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { IDadosAtivosPropostaSimplificada, IDadosAtivosPropostaSwap, IDadosPiclks, IDadosPropostaSimplificada, IDadosPropostaTroca, IDadosPropostas, IDadosSavePropostas, IListaDadosSaveProposta, PropostaService } from "../../shered/services/api/propostas/PropostaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { DataGrid, GridColDef, GridRowParams } from "@mui/x-data-grid";
import { ptBR } from '@mui/x-data-grid/locales';

export const DetalheDePropostassimples: React.FC = () => {
    const theme = useTheme();
    const user = CookieService.get("access_user");
    const { id = 'nova' } = useParams<"id">();
    const { formRef, save } = useVForm();
    let codLocal = localStorage.getItem("@codigoLiga");
    const { themeName } = useAppThemeContext();
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { logout } = useAuthContext();
    //const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstFranquiaDrop, setLstFranquiaDrop] = useState<ILstDrop[]>([]);
    const [lstFranquia, setLstFranquia] = useState<IDetalheFranquia[]>([]);
    const [lstDadosPropostaEnvia, setLstDadosPropostaEnvia] = useState<IDadosPropostaTroca[]>([]);
    const [redirecionar, setRedirecionar] = useState("");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [mercadoAberto, setMercadoAberto] = useState(false);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [nomeLiga, setNomeLiga] = useState("");
    const [logoImage, setLogoImage] = useState("");
    const [observacao, setObservacao] = useState("");
    const [qtdFranquias, setQtdFranquias] = useState(0);
    const [codigoFranquia, setCodigoFranquia] = useState(0);
    const [franquiaEnvia, setFranquiaEnvia] = useState(0);
    const [franquiaRecebe, setFranquiaRecebe] = useState(0);
    const [codigoTemporada, setCodigoTemporada] = useState(0);
    const [codigoTipoAtivo, setCodigoTipoAtivo] = useState(0);
    //const [codigoAtivo, setCodigoAtivo] = useState(0);
    const [dadosObservacao, setDadosObservacao] = useState<string[]>([]);
    const [separarMultaTemporada, setSepararMultaTemporada] = useState(0);
    const [dadosPropostaFranquia1, setDadosPropostaFranquia1] = useState<any>();
    const [lstDadosJogadoresF1, setLstDadosJogadoresF1] = useState<IDadosAtivosPropostaSimplificada[]>([]);
    const [lstDadosPicksF1, setLstDadosPicksF1] = useState<any[]>([]);
    const [lstDadosMultasF1, setLstDadosMultasF1] = useState<any[]>([]);

    const [dadosPropostaFranquia2, setDadosPropostaFranquia2] = useState<any>();
    const [lstDadosJogadoresF2, setLstDadosJogadoresF2] = useState<IDadosAtivosPropostaSimplificada[]>([]);
    const [lstDadosPicksF2, setLstDadosPicksF2] = useState<any[]>([]);
    const [lstDadosMultasF2, setLstDadosMultasF2] = useState<any[]>([]);

    const [lstIdsJogadorF1, setLstIdsJogadorF1] = useState<any[]>([]);
    const [lstIdsPicksF1, setLstIdsPicksF1] = useState<any[]>([]);
    const [lstIdsMultasF1, setLstIdsMultasF1] = useState<any[]>([]);

    const [lstIdsJogadorF2, setLstIdsJogadorF2] = useState<any[]>([]);
    const [lstIdsPicksF2, setLstIdsPicksF2] = useState<any[]>([]);
    const [lstIdsMultasF2, setLstIdsMultasF2] = useState<any[]>([]);

    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });
    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options);

    useEffect(() => {
        setRemoveLoading(false);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        else {
            const fetchData = async () => {
                let minhaFranquia = 0;
                await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const liga = result.dado;
                        setDadosLiga(liga);
                        setNomeLiga(liga.nome);
                        setLogoImage(liga.caminho_Logo);
                        setQtdFranquias(liga.quantidade_Franquia);
                        setCodigoFranquia(liga.codigo_Franquia);
                        setCodigoTemporada(liga.codigo_Temporada);
                        setSepararMultaTemporada(liga.separar_Multa_Temporada);
                        setFranquiaEnvia(liga.codigo_Franquia);
                        minhaFranquia = liga.codigo_Franquia;
                        setMercadoAberto(liga.abertura_Mercado);
                        if (liga.abertura_Mercado !== true) {
                            navigate(`/liga/propostas/completa`);
                            return;
                        }
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    });

                setIsLoading(true);


                await FranquiaService.getByIdLiga(Number(codigoLiga))
                    .then((result) => {
                        setLstFranquia(result.dado);
                        let lstFranquia = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome, outros: f.caminho_Logo, descricao: f.nome_Usuario }));
                        setLstFranquiaDrop(lstFranquia);
                    })
                    .catch((errors) => {
                        setRemoveLoading(true);
                        setShowModalMensagem(true);
                        if (errors.response.data.statusHTTP === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        else {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                    });
                setRemoveLoading(true);
                setIsLoading(false);
            }
            fetchData();
        }
    }, [codigoLiga, id]);

    const handleSave = async (dados: IDadosSavePropostas) => {

        setLstDadosPropostaEnvia([]);
        setRemoveLoading(false);
        setIsLoading(true);
        setShowModalMensagem(false);
        setObservacao(JSON.stringify(dadosObservacao));
        let lst: IListaDadosSaveProposta[] = [];

        if (lstIdsJogadorF1.length > 0) {
            lstIdsJogadorF1.length > 0 && lstIdsJogadorF1.map(codigoAtivo =>
                lst.push({
                    codigo_Franquia_Envia: franquiaEnvia,
                    codigo_Franquia_Recebe: franquiaRecebe,
                    codigo_Jogador: lstDadosJogadoresF1.filter(f => f.codigo_Tipo_Ativo === 2 && f.codigo === codigoAtivo).length !== 0 ? null : codigoAtivo,
                    codigo_Jogador_Dispensa: lstDadosJogadoresF1.filter(f => f.codigo_Tipo_Ativo === 2 && f.codigo === codigoAtivo).length !== 0 ? codigoAtivo : null,
                    tipo_Ativo: lstDadosJogadoresF1.filter(f => f.codigo_Tipo_Ativo === 2 && f.codigo === codigoAtivo).length !== 0 ? 2 : 1,

                }));

        }
        if (lstIdsJogadorF2.length > 0) {
            lstIdsJogadorF2.length > 0 && lstIdsJogadorF2.map((codigoAtivo, i) =>
                lst.push({
                    codigo_Franquia_Envia: franquiaRecebe,
                    codigo_Franquia_Recebe: franquiaEnvia,
                    codigo_Jogador: lstDadosJogadoresF2.filter(f => f.codigo_Tipo_Ativo === 2 && f.codigo === codigoAtivo).length !== 0 ? null : codigoAtivo,
                    codigo_Jogador_Dispensa: lstDadosJogadoresF2.filter(f => f.codigo_Tipo_Ativo === 2 && f.codigo === codigoAtivo).length !== 0 ? codigoAtivo : null,
                    tipo_Ativo: lstDadosJogadoresF2.filter(f => f.codigo_Tipo_Ativo === 2 && f.codigo === codigoAtivo).length !== 0 ? 2 : 1,
                }));
        }
        if (lstIdsPicksF1.length > 0) {
            lstIdsPicksF1.length > 0 && lstIdsPicksF1.map((codigoAtivo, i) =>
                lst.push({
                    codigo_Franquia_Envia: franquiaEnvia,
                    codigo_Franquia_Recebe: franquiaRecebe,
                    codigo_Pick_Franquia: codigoAtivo,
                    tipo_Ativo: 4,
                }));
        }
        if (lstIdsPicksF2.length > 0) {
            lstIdsPicksF2.length > 0 && lstIdsPicksF2.map((codigoAtivo, i) =>
                lst.push({
                    codigo_Franquia_Envia: franquiaRecebe,
                    codigo_Franquia_Recebe: franquiaEnvia,
                    codigo_Pick_Franquia: codigoAtivo,
                    tipo_Ativo: 4,
                }));
        }
        if (lstIdsMultasF1.length > 0) {
            lstIdsMultasF1.length > 0 && lstIdsMultasF1.map((codigoAtivo, i) =>
                lst.push({
                    codigo_Franquia_Envia: franquiaEnvia,
                    codigo_Franquia_Recebe: franquiaRecebe,
                    codigo_Multa: codigoAtivo,
                    tipo_Ativo: 3,
                }));
        }

        if (lstIdsMultasF2.length > 0) {
            lstIdsMultasF2.length > 0 && lstIdsMultasF2.map((codigoAtivo, i) =>
                lst.push({
                    codigo_Franquia_Envia: franquiaRecebe,
                    codigo_Franquia_Recebe: franquiaEnvia,
                    codigo_Multa: codigoAtivo,
                    tipo_Ativo: 3,
                }));
        }

        dados = {
            ...dados,
            codigo_Liga: codigoLiga !== null ? Number(codigoLiga) : 0,
            codigo_Temporada: codigoTemporada,
            codUsuCriacao: user.codUsuario,
            data_Hora: new Date(),
            observacao: JSON.stringify(dadosObservacao),
            proposta_Troca: lst
        }       

        PropostaService.Create(dados)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Proposta cadastrada com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/liga/propostas/completa`);
            })
            .catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível cadastrar a proposta! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });

        setIsLoading(false);
        setRemoveLoading(true);

    };


    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const handleRowsSelectionJogF1 = async (ids: any[], codigoTipoAtivo: number, franquia: number) => {
       
        setIsLoading(true);
        setRemoveLoading(false);
        setLstIdsJogadorF1(ids);
        /// setShowBotaoGerarProposta(ids.length > 0);

        // let lstitens = lstDadosPropostaCabecalho.find(f => (f.codigo_Franquia_Envia === franquiaEnvia))?.dados_Propostas;
        // let indexItem = lstitens !== null && lstitens !== undefined ? lstitens?.length + 1 : 1;

        // let fraquiaEnvolvidaEnvia = lstFranquiaDrop.find(f => f.codigo === franquiaEnvia);
        // let fraquiaEnvolvidaRecebe = lstFranquiaDrop.find(f => f.codigo === franquiaRecebe);
        // if (codigoTipoAtivo === 1) {
        //     let lstJogadores = franquia === 1 ? lstDadosJogadoresF1.map((f, i) => ({ codigo: f.codigo, label: f.nome, outros: f.foto, valor: f.valor_Contrato, descricao: f.tempo_Contrato.toString() })) :  lstDadosJogadoresF2.map((f, i) => ({ codigo: f.codigo, label: f.nome, outros: f.foto, valor: f.valor_Contrato, descricao: f.tempo_Contrato.toString() }));
        //     setLstAtivos(lstJogadores !== undefined ? lstJogadores : []);
        // }      
        // else if (codigoTipoAtivo === 3) {           
        //         let lstMultas =franquia === 1 ? lstDadosMultasF1.map((f, i) => ({ codigo: f.codigo, label:f.nome_Jogador + " (" + f.descricao_Temporada + ") - R$ " + moedaRealLocaleValue(f.valor_Multa), outros: f.nome_Jogador, valor: "R$ " + moedaRealLocaleValue(f.valor_Multa), descricao: f.descricao_Temporada })) : lstDadosMultasF2.map((f, i) => ({ codigo: f.codigo, label:f.nome_Jogador + " (" + f.descricao_Temporada + ") - R$ " + moedaRealLocaleValue(f.valor_Multa), outros: f.nome_Jogador, valor: "R$ " + moedaRealLocaleValue(f.valor_Multa), descricao: f.descricao_Temporada }));                          
        //         setLstAtivos(lstMultas !== undefined ? lstMultas : []);

        // }
        // else if (codigoTipoAtivo === 4) {
        //     let lstPicks =franquia === 1 ? lstDadosPicksF1.map((f, i) => ({
        //         codigo: f.codigo,
        //         label: f.rodada === 1 ? "First - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem : "Second - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem,
        //         outros: f.franquia_Origem,
        //         descricao: f.rodada === 1 ? "First - " + f.ano.toString() : "Second - " + f.ano.toString(),
        //         valor: f.posicao_Final !== undefined ? f.descricao_Posicao_Final : "",
        //         rodada: f.rodada

        //     })) : lstDadosPicksF2.map((f, i) => ({
        //         codigo: f.codigo,
        //         label: f.rodada === 1 ? "First - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem : "Second - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem,
        //         outros: f.franquia_Origem,
        //         descricao: f.rodada === 1 ? "First - " + f.ano.toString() : "Second - " + f.ano.toString(),
        //         valor: f.posicao_Final !== undefined ? f.descricao_Posicao_Final : "",
        //         rodada: f.rodada

        //     })) ;
        //     setLstAtivos(lstPicks !== undefined ? lstPicks : []);
        // }

        // ids.map((codigoAtivo,i) => {
        //     var proposta: any = {
        //         codigo: i+1,
        //         codigo_Franquia_Envia: franquiaEnvia,
        //         nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
        //         logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
        //         codigo_Franquia_Recebe: franquiaRecebe,
        //         nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
        //         logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
        //         codigo_Jogador: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? codigoAtivo : 0,
        //         nome_Jogador: codigoTipoAtivo === 1 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : codigoTipoAtivo === 3 && separarMultaTemporada === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros : "",
        //         valor_Jogador: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.valor : "",
        //         tempo_Contrato_Jogador: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.descricao : "0,00",
        //         codigo_Multa: codigoTipoAtivo === 3 ? codigoAtivo : 0,
        //         valor_Multa: codigoTipoAtivo === 3 ? separarMultaTemporada === 3 ? formatNumber.format(Number(valorMultaEditada)) : lstAtivos.find(f => f.codigo === codigoAtivo)?.valor : "0",
        //         tipo_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.tipo_Multa : "0",
        //         codigo_Temporada_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros : "",
        //         descricao_Temporada_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.descricao : "",
        //         nome_Jogador_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : "",
        //         quantidade_Anos_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.quantidade_Anos_Multa : 1,
        //         codigo_Jogador_Dispensa: codigoTipoAtivo === 2 ? codigoAtivo : 0,
        //         nome_Jogador_Dispensa: codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : "",
        //         codigo_Pick_Franquia: codigoTipoAtivo === 5 || codigoTipoAtivo === 4 || codigoTipoAtivo === 6 ? codigoAtivo : 0,
        //         rodada_Pick: codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.rodada : codigoTipoAtivo === 5 || codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.outros : "",
        //         ano_Pick: codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.descricao : codigoTipoAtivo === 5 || codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.descricao : "",
        //         primeira_Pick_Swap: codigoTipoAtivo === 6 || codigoTipoAtivo === 5 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : "",
        //         segunda_Pick_Swap: codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.label : "",
        //         terceira_Pick_Swap: codigoTipoAtivo === 6 || codigoTipoAtivo === 5 ? lstAtivos.find(f => f.codigo === codigoAtivoSwapProtegida)?.label : "",
        //         descricao_Posicao_Final: codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.valor : "",
        //         codigo_Proposta_Troca_Nova: 0,
        //         swap: codigoTipoAtivo === 6,
        //         codigo_Franquia_Swap: codigoTipoAtivo === 6 ? franquiaRecebe : null,
        //         codigo_Pick_Swap: codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.codigo : "",
        //         protecao: codigoTipoAtivo === 5 || (inicioProtecao > 0 && fimProtecao > 0),
        //         inicio_Protecao: inicioProtecao,
        //         fim_Protecao: fimProtecao,
        //         codigo_Pick_Novo: codigoAtivoSwapProtegida,
        //         tipo_Ativo: codigoTipoAtivo,
        //         nome_Franquia_Origem_Pick: codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros : "",
        //         imagem: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros
        //             : codigoTipoAtivo === 3 ? imagemMulta
        //                 : codigoTipoAtivo === 4 ? imagemPicks
        //                     : codigoTipoAtivo === 5 ? imagemPicksProtegida
        //                         : codigoTipoAtivo === 6 ? imagemSwap
        //                             : ""
        //     };

        //     if (lstDadosPropostaCabecalho.length === 0) {
        //         var cabecalhoProp: any = [{
        //             codigo: 1,
        //             logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
        //             codigo_Franquia_Envia: franquiaEnvia,
        //             nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
        //             nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
        //             logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
        //             codigo_Franquia_Recebe: franquiaRecebe,
        //             nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
        //             nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
        //             dados_Propostas: [proposta]
        //         }];

        //         setLstDadosPropostaCabecalho(cabecalhoProp);

        //     }
        //     else {
        //         if (lstDadosPropostaCabecalho.length > 0 && lstDadosPropostaCabecalho.find(f => f.codigo_Franquia_Envia === franquiaEnvia) !== undefined) {
        //             lstDadosPropostaCabecalho.find(f => f.codigo_Franquia_Envia === franquiaEnvia)?.dados_Propostas.push(proposta);

        //         }
        //         else {

        //             setLstDadosPropostaCabecalho([...lstDadosPropostaCabecalho, {
        //                 codigo: lstDadosPropostaCabecalho.length + 1,
        //                 logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
        //                 codigo_Franquia_Envia: franquiaEnvia,
        //                 nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
        //                 nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
        //                 logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
        //                 codigo_Franquia_Recebe: franquiaRecebe,
        //                 nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
        //                 nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
        //                 situacao: 1,
        //                 dados_Propostas: [proposta]
        //             }]);

        //         }
        //     }
        // })
        setIsLoading(false);
        setRemoveLoading(true);
    }
    const handleRowsSelectionJogF2 = async (ids: any[], codigoTipoAtivo: number, franquia: number) => {
       
        setIsLoading(true);
        setRemoveLoading(false);
        setLstIdsJogadorF2(ids);
        setIsLoading(false);
        setRemoveLoading(true);

    }

    const handleRowsSelectionPicksF2 = async (ids: any[], codigoTipoAtivo: number, franquia: number) => {
       
        setIsLoading(true);
        setRemoveLoading(false);
        setLstIdsPicksF2(ids);
        setIsLoading(false);
        setRemoveLoading(true);

    }

    const handleRowsSelectionPicksF1 = async (ids: any[], codigoTipoAtivo: number, franquia: number) => {
       
        setIsLoading(true);
        setRemoveLoading(false);
        setLstIdsPicksF1(ids);
        setIsLoading(false);
        setRemoveLoading(true);

    }

    const handleRowsSelectionMultaF1 = async (ids: any[], codigoTipoAtivo: number, franquia: number) => {
       
        setIsLoading(true);
        setRemoveLoading(false);
        setLstIdsMultasF1(ids);
        setIsLoading(false);
        setRemoveLoading(true);

    }

    const handleRowsSelectionMultaF2 = async (ids: any[], codigoTipoAtivo: number, franquia: number) => {
       
        setIsLoading(true);
        setRemoveLoading(false);
        setLstIdsMultasF2(ids);
        setIsLoading(false);
        setRemoveLoading(true);
    }

    // const handleAdicionar = (ids: any, codigoTipoAtivo: number) => {

    //     setDadosObservacao([...dadosObservacao, codigoTipoAtivo === 1 ? "Adicionado item do tipo jogadores"
    //         : codigoTipoAtivo === 2 ? "Adicionado item do tipo jogadores dispensa"
    //             : codigoTipoAtivo === 3 ? "Adicionado item do tipo multa"
    //                 : codigoTipoAtivo === 5 ? "Adicionado item do tipo Pick Protegida"
    //                     : codigoTipoAtivo === 6 ? "Adicionado item do tipo Swap"
    //                         : "Adicionado item do tipo pick"
    //     ]);

    //     let lstitens = lstDadosPropostaCabecalho.find(f => (f.codigo_Franquia_Envia === franquiaEnvia))?.dados_Propostas;
    //     let indexItem = lstitens !== null && lstitens !== undefined ? lstitens?.length + 1 : 1;

    //     let fraquiaEnvolvidaEnvia = lstFranquiaDrop.find(f => f.codigo === franquiaEnvia);
    //     let fraquiaEnvolvidaRecebe = lstFranquiaDrop.find(f => f.codigo === franquiaRecebe);
    //     var proposta: any = {
    //         codigo: indexItem,
    //         codigo_Franquia_Envia: franquiaEnvia,
    //         nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
    //         logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
    //         codigo_Franquia_Recebe: franquiaRecebe,
    //         nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
    //         logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
    //         codigo_Jogador: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? codigoAtivo : 0,
    //         nome_Jogador: codigoTipoAtivo === 1 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : codigoTipoAtivo === 3 && separarMultaTemporada === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros : "",
    //         valor_Jogador: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.valor : "",
    //         tempo_Contrato_Jogador: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.descricao : "0,00",
    //         codigo_Multa: codigoTipoAtivo === 3 ? codigoAtivo : 0,
    //         valor_Multa: codigoTipoAtivo === 3 ? separarMultaTemporada === 3 ? formatNumber.format(Number(valorMultaEditada)) : lstAtivos.find(f => f.codigo === codigoAtivo)?.valor : "0",
    //         tipo_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.tipo_Multa : "0",
    //         codigo_Temporada_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros : "",
    //         descricao_Temporada_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.descricao : "",
    //         nome_Jogador_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : "",
    //         quantidade_Anos_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.quantidade_Anos_Multa : 1,
    //         codigo_Jogador_Dispensa: codigoTipoAtivo === 2 ? codigoAtivo : 0,
    //         nome_Jogador_Dispensa: codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : "",
    //         codigo_Pick_Franquia: codigoTipoAtivo === 5 || codigoTipoAtivo === 4 || codigoTipoAtivo === 6 ? codigoAtivo : 0,
    //         rodada_Pick: codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.rodada : codigoTipoAtivo === 5 || codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.outros : "",
    //         ano_Pick: codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.descricao : codigoTipoAtivo === 5 || codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.descricao : "",
    //         primeira_Pick_Swap: codigoTipoAtivo === 6 || codigoTipoAtivo === 5 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : "",
    //         segunda_Pick_Swap: codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.label : "",
    //         terceira_Pick_Swap: codigoTipoAtivo === 6 || codigoTipoAtivo === 5 ? lstAtivos.find(f => f.codigo === codigoAtivoSwapProtegida)?.label : "",
    //         descricao_Posicao_Final: codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.valor : "",
    //         codigo_Proposta_Troca_Nova: 0,
    //         swap: codigoTipoAtivo === 6,
    //         codigo_Franquia_Swap: codigoTipoAtivo === 6 ? franquiaRecebe : null,
    //         codigo_Pick_Swap: codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.codigo : "",
    //         protecao: codigoTipoAtivo === 5 || (inicioProtecao > 0 && fimProtecao > 0),
    //         inicio_Protecao: inicioProtecao,
    //         fim_Protecao: fimProtecao,
    //         codigo_Pick_Novo: codigoAtivoSwapProtegida,
    //         tipo_Ativo: codigoTipoAtivo,
    //         nome_Franquia_Origem_Pick: codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros : "",
    //         imagem: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros
    //             : codigoTipoAtivo === 3 ? imagemMulta
    //                 : codigoTipoAtivo === 4 ? imagemPicks
    //                     : codigoTipoAtivo === 5 ? imagemPicksProtegida
    //                         : codigoTipoAtivo === 6 ? imagemSwap
    //                             : ""
    //     };

    //     if (lstDadosPropostaCabecalho.length === 0) {
    //         var cabecalhoProp: any = [{
    //             codigo: 1,
    //             logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
    //             codigo_Franquia_Envia: franquiaEnvia,
    //             nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
    //             nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
    //             logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
    //             codigo_Franquia_Recebe: franquiaRecebe,
    //             nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
    //             nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
    //             dados_Propostas: [proposta]
    //         }];

    //         setLstDadosPropostaCabecalho(cabecalhoProp);

    //     }
    //     else {
    //         if (lstDadosPropostaCabecalho.length > 0 && lstDadosPropostaCabecalho.find(f => f.codigo_Franquia_Envia === franquiaEnvia) !== undefined) {
    //             lstDadosPropostaCabecalho.find(f => f.codigo_Franquia_Envia === franquiaEnvia)?.dados_Propostas.push(proposta);

    //         }
    //         else {

    //             setLstDadosPropostaCabecalho([...lstDadosPropostaCabecalho, {
    //                 codigo: lstDadosPropostaCabecalho.length + 1,
    //                 logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
    //                 codigo_Franquia_Envia: franquiaEnvia,
    //                 nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
    //                 nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
    //                 logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
    //                 codigo_Franquia_Recebe: franquiaRecebe,
    //                 nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
    //                 nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
    //                 situacao: 1,
    //                 dados_Propostas: [proposta]
    //             }]);

    //         }
    //     }



    //     if (lstPropostaRecebe.length === 0) {
    //         var cabecalhoProp: any = [{
    //             codigo: 1,
    //             logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
    //             codigo_Franquia_Envia: franquiaEnvia,
    //             nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
    //             nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
    //             logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
    //             codigo_Franquia_Recebe: franquiaRecebe,
    //             nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
    //             nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
    //             dados_Propostas: [proposta]
    //         }];


    //         setLstPropostaRecebe(cabecalhoProp);

    //     }
    //     else {

    //         if (lstPropostaRecebe.length > 0 && lstPropostaRecebe.find(f => f.codigo_Franquia_Recebe === franquiaRecebe) !== undefined) {
    //             lstPropostaRecebe.find(f => f.codigo_Franquia_Recebe === franquiaRecebe)?.dados_Propostas.push(proposta);
    //         }
    //         else {

    //             setLstPropostaRecebe([...lstPropostaRecebe, {
    //                 codigo: lstDadosPropostaCabecalho.length + 1,
    //                 logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
    //                 codigo_Franquia_Envia: franquiaEnvia,
    //                 nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
    //                 nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
    //                 logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
    //                 codigo_Franquia_Recebe: franquiaRecebe,
    //                 nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
    //                 nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
    //                 situacao: 1,
    //                 dados_Propostas: [proposta]
    //             }]);

    //         }
    //         if (lstPropostaRecebe.length > 0 && lstPropostaRecebe.find(f => f.codigo_Franquia_Recebe === franquiaRecebe) === undefined) {
    //             setLstPropostaRecebe([...lstPropostaRecebe, {
    //                 codigo: lstDadosPropostaCabecalho.length + 1,
    //                 logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
    //                 codigo_Franquia_Envia: franquiaEnvia,
    //                 nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
    //                 nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
    //                 logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
    //                 codigo_Franquia_Recebe: franquiaRecebe,
    //                 nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
    //                 nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
    //                 situacao: 1,
    //                 dados_Propostas: [proposta]
    //             }]);
    //         }
    //     }
    //     setLstAtivos([]);
    //     setCodigoTipoAtivo(0);
    //     setValorMultaEditada("");
    //     setShowAtivosSwap(false);
    //     setCodigoAtivo(0);
    //     setCodigoAtivoSwap(0);
    //     setCodigoAtivoSwapProtegida(0);
    //     setInicioProtecao(0);
    //     setFimProtecao(0);

    // }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);

    }


    const handleSelecionarFranquia = (e: { target: { name: string; value: any; }; }) => {
        setIsLoading(true);
        setRemoveLoading(false);
        setFranquiaRecebe(Number(e.target.value));
        PropostaService.getDadosPropostaSimples(codigoFranquia, Number(e.target.value))
            .then((result) => {
                let dadosProposta = result.dado;              
                let dadosPropostasFranquia1 = dadosProposta.franquia1;
                let dadosPropostasFranquia2 = dadosProposta.franquia2;
                setDadosPropostaFranquia1(dadosPropostasFranquia1);
                setLstDadosJogadoresF1(dadosPropostasFranquia1.itens.filter(f => f.codigo_Tipo_Ativo === 1 || f.codigo_Tipo_Ativo === 2))
                setLstDadosPicksF1(dadosPropostasFranquia1.itens.filter(f => f.codigo_Tipo_Ativo === 4));
                setLstDadosMultasF1(dadosPropostasFranquia1.itens.filter(f => f.codigo_Tipo_Ativo === 3));
                setDadosPropostaFranquia2(dadosProposta.franquia2);
                setLstDadosJogadoresF2(dadosPropostasFranquia2.itens.filter(f => f.codigo_Tipo_Ativo === 1 || f.codigo_Tipo_Ativo === 2))
                setLstDadosPicksF2(dadosPropostasFranquia2.itens.filter(f => f.codigo_Tipo_Ativo === 4));
                setLstDadosMultasF2(dadosPropostasFranquia2.itens.filter(f => f.codigo_Tipo_Ativo === 3));
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                else {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da proposta! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`0`);
                    return;
                }
            });

    }

    const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {

        let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;
        //console.log(posicoes);
        let qtd = posicoes.split("|").length;
        let arrImagens = posicoes.split("|");

        let imgs = qtd === 1 ? <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 22} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%" }} />
            : qtd === 2 ?
                <>  <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 22} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 22} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>
                : <> <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 22} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 22} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", marginLeft: 4 }} />
                    <img src={arrImagens[2]} alt={"img3"} width={UtilidadeService.isMobile() ? 15 : 22} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>

        return imgs
    }


    const columnsJogadores: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'CÓDIGO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'codigo_Tipo_Ativo',
            headerName: 'ATIVO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'codigo_Jogador',
            headerName: 'COD. JOGADOR',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'nome_Jogador',
            headerName: 'NOME',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 100 : 120,
            sortable: false,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'posicao_1',
            headerName: 'POSIÇÃO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 80 : 90,
            sortable: false,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => carregaPosicao(params.row.posicao_1, params.row.posicao_2, params.row.posicao_3),
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'jogos',
            headerName: 'JOGOS',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 65,
            maxWidth: UtilidadeService.isMobile() ? 60 : 65,
            sortable: false,
            editable: false,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'minutos',
            headerName: 'MIN',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 65,
            sortable: false,
            editable: false,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : null
        },
        {
            field: 'peso_Total',
            headerName: 'FGP ',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 65,
            sortable: false,
            editable: false,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : null
        },
        {
            field: 'peso_Minutos',
            headerName: 'FPM ',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 65,
            sortable: false,
            editable: false,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : null
        },
        {
            field: 'valor_Contrato',
            headerName: 'VALOR',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            sortable: false,
            editable: false,
            headerClassName: 'super-app-theme--header',
            headerAlign: "right",
            align: "right",
            renderCell: (params) => (formatNumber.format(params.value)),
        },
        {
            field: 'tempo_Contrato',
            headerName: 'ANOS',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 65,
            sortable: false,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header',
            //renderCell: (params) => (params.value + " Anos"),
        },
    ];

    const columnsPicks: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'CÓDIGO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: false,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'codigo_Tipo_Ativo',
            headerName: 'ATIVO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: false,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'codigo_Pick',
            headerName: 'PICK',           
            minWidth: UtilidadeService.isMobile() ? 60 : 100,
            maxWidth: UtilidadeService.isMobile() ? 60 : 100,
            sortable: false,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.row.descricao_Pick.split("-")[0]}
                    </Box>
                );
            },
        },
        {
            field: 'descricao_Pick',
            headerName: 'DESCRIÇÃO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 250,
            sortable: false,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },

    ];

    const columnsMulta: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'CÓDIGO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'codigo_Tipo_Ativo',
            headerName: 'ATIVO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'codigo_Multa',
            headerName: 'COD. MULTA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'nome_Jogador_Multa',
            headerName: 'DESCRIÇÃO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'tempo_Multa',
            headerName: 'ANOS',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'valor_Multa',
            headerName: 'VALOR',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (formatNumber.format(params.value)),
            headerAlign: "right",
            align: "right",
        },

    ];

    return (
        <LayoutBaseDePagina
            titulo={`Liga - ${nomeLiga}`}
            showLogoImg={logoImage}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={true}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmVoltar={() => navigate("/liga/propostas/completa")}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container padding={2} spacing={2} display={mercadoAberto ? "flex" : "none"}>
                        <Grid container size={{ xs: 12, sm: 12 }} >
                            <Grid size={{ xs: 12, sm: 9, md: 9 }} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Criar Proposta</Typography>
                                <hr />
                            </Grid>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={1}>
                            <Grid size={{ xs: 11, sm: 3, md: 3 }}  >
                                <FormControl fullWidth disabled={isLoading}>
                                    <InputLabel id="demo-simple-select-label">Minha Franquia</InputLabel>
                                    <Select
                                        native={false}
                                        value={franquiaEnvia}
                                        label="Minha Franquia"
                                        defaultValue={codigoFranquia}
                                        disabled
                                        onChange={(e) => { setFranquiaEnvia(Number(e.target.value)); }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            lstFranquiaDrop.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }

                                    </Select>
                                </FormControl >
                            </Grid>
                            <Grid size={{ xs: 11, sm: 3, md: 3 }}  >
                                <FormControl fullWidth disabled={isLoading}>
                                    <InputLabel id="demo-simple-select-label">Franquia</InputLabel>
                                    <Select
                                        native={false}
                                        value={franquiaRecebe}
                                        label="Franquia"
                                        defaultValue={0}
                                        onChange={(e) => { setFranquiaRecebe(Number(e.target.value)); handleSelecionarFranquia(e) }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            lstFranquiaDrop.filter(d => d.codigo !== franquiaEnvia).map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }

                                    </Select>
                                </FormControl >
                            </Grid>
                        </Grid>
                        {!removeLoading && <Loading />}
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" direction="row" padding={1}>
                            {lstDadosJogadoresF1.length > 0 && lstDadosJogadoresF2.length > 0 && (<>
                                <Grid size={{ xs: 12, sm: 12 }} >
                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Troca Jogadores</Typography>
                                    <hr />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Grid container size={{ xs: 12, sm: 12 }} display={"flex"} alignSelf={"center"} gap={1}>
                                        <Grid size={{ xs: 1, sm: 1 }} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                            <img src={dadosPropostaFranquia1.logo != null ? dadosPropostaFranquia1.logo : "../../semimagemescudo.png"} alt={dadosPropostaFranquia1.nome} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />
                                        </Grid>
                                        <Grid size={{ xs: 11, sm: 11 }} display={"flex"} alignSelf={"center"} padding={1}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{dadosPropostaFranquia1.nome}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP GASTO: ${formatNumber.format(dadosPropostaFranquia1.caP_Gasto)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP DISPONÍVEL: ${formatNumber.format(dadosPropostaFranquia1.caP_Disponivel)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`SLOT DISPONÍVEL: ${dadosPropostaFranquia1.slot_Disponivel} `}</Typography>
                                        </Grid>
                                        <Box sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                                justifySelf: "center",
                                                alignSelf: "center",

                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: themeName === "light" ? "black" : "auto",
                                            },
                                            // '& .MuiDataGrid-columnHeaderRow': {
                                            //     maxHeight: UtilidadeService.isMobile() ? 38 : 56,
                                            //     minHeight: UtilidadeService.isMobile() ? 38 : 56,
                                            //     lineHeight: UtilidadeService.isMobile() ? 38 : 56,
                                            // },    
                                            // '& .MuiDataGrid-columnHeaders': {
                                            //     maxHeight: UtilidadeService.isMobile() ? 38 : 56,
                                            //     minHeight: UtilidadeService.isMobile() ? 38 : 56,
                                            //     lineHeight: UtilidadeService.isMobile() ? 38 : 56,
                                            // }    


                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                autoHeight
                                                columnHeaderHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                getRowId={(rows) => rows.codigo_Jogador}
                                                rows={lstDadosJogadoresF1}
                                                columns={columnsJogadores}

                                                rowHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 20,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{
                                                    codigo: false,
                                                    codigo_Tipo_Ativo: false,
                                                    codigo_Jogador: false

                                                }}
                                                pageSizeOptions={[20]}
                                                disableRowSelectionOnClick
                                                disableVirtualization
                                                checkboxSelection
                                                disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                disableColumnMenu={true}
                                                onRowSelectionModelChange={(ids) => {
                                                    handleRowsSelectionJogF1(ids, 1, 1);

                                                }}
                                                // isRowSelectable={(params: GridRowParams) => params.row.status < 5}
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 10 : 13,
                                                    fontWeight: 700,
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Grid container size={{ xs: 12, sm: 12 }} display={"flex"} alignSelf={"center"} gap={1}>
                                        <Grid size={{ xs: 1, sm: 1 }} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                            <img src={dadosPropostaFranquia2.logo != null ? dadosPropostaFranquia2.logo : "../../semimagemescudo.png"} alt={dadosPropostaFranquia2.nome} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />
                                        </Grid>
                                        <Grid size={{ xs: 11, sm: 11 }} display={"flex"} alignSelf={"center"} padding={1}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{dadosPropostaFranquia2.nome}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP GASTO: ${formatNumber.format(dadosPropostaFranquia2.caP_Gasto)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP DISPONÍVEL: ${formatNumber.format(dadosPropostaFranquia2.caP_Disponivel)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`SLOT DISPONÍVEL: ${dadosPropostaFranquia2.slot_Disponivel} `}</Typography>
                                        </Grid>
                                        <Box sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: themeName === "light" ? "black" : "auto",
                                            }
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                autoHeight
                                                columnHeaderHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                getRowId={(rows) => rows.codigo_Jogador}
                                                rows={lstDadosJogadoresF2}
                                                columns={columnsJogadores}
                                                rowHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 20,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{
                                                    codigo: false,
                                                    codigo_Tipo_Ativo: false,
                                                    codigo_Jogador: false

                                                }}
                                                pageSizeOptions={[20]}
                                                disableRowSelectionOnClick
                                                disableVirtualization
                                                checkboxSelection
                                                disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                disableColumnMenu={true}
                                                onRowSelectionModelChange={(ids) => {
                                                    handleRowsSelectionJogF2(ids, 1, 2);

                                                }}
                                                // isRowSelectable={(params: GridRowParams) => params.row.status < 5}
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 10 : 13,
                                                    fontWeight: 700,
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </>)}
                            <Grid size={{ xs: 12, sm: 12 }} >
                                {!removeLoading && <Loading />}
                            </Grid>
                            {lstDadosPicksF1.length > 0 && lstDadosPicksF2.length > 0 && (<>
                                <Grid size={{ xs: 12, sm: 12 }} >
                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Troca Picks</Typography>
                                    <hr />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Grid container size={{ xs: 12, sm: 12 }} display={"flex"} alignSelf={"center"} gap={1}>
                                        <Grid size={{ xs: 1, sm: 1 }} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                            <img src={dadosPropostaFranquia1.logo != null ? dadosPropostaFranquia1.logo : "../../semimagemescudo.png"} alt={dadosPropostaFranquia1.nome} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />
                                        </Grid>
                                        <Grid size={{ xs: 11, sm: 11 }} display={"flex"} alignSelf={"center"} padding={1}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{dadosPropostaFranquia1.nome}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP GASTO: ${formatNumber.format(dadosPropostaFranquia1.caP_Gasto)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP DISPONÍVEL: ${formatNumber.format(dadosPropostaFranquia1.caP_Disponivel)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`SLOT DISPONÍVEL: ${dadosPropostaFranquia1.slot_Disponivel} `}</Typography>
                                        </Grid>

                                        <Box sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: themeName === "light" ? "black" : "auto",
                                            }
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                autoHeight
                                                columnHeaderHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                getRowId={(rows) => rows.codigo_Pick}
                                                rows={lstDadosPicksF1}
                                                columns={columnsPicks}
                                                rowHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 20,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{
                                                    codigo: false,
                                                    codigo_Tipo_Ativo: false,
                                                }}
                                                pageSizeOptions={[20]}
                                                disableRowSelectionOnClick
                                                disableVirtualization
                                                checkboxSelection
                                                disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                disableColumnMenu={true}
                                                onRowSelectionModelChange={(ids) => {
                                                    handleRowsSelectionPicksF1(ids, 4, 1);

                                                }}
                                                // isRowSelectable={(params: GridRowParams) => params.row.status < 5}
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Grid container size={{ xs: 12, sm: 12 }} display={"flex"} alignSelf={"center"} gap={1}>
                                        <Grid size={{ xs: 1, sm: 1 }} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                            <img src={dadosPropostaFranquia2.logo != null ? dadosPropostaFranquia2.logo : "../../semimagemescudo.png"} alt={dadosPropostaFranquia2.nome} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />
                                        </Grid>
                                        <Grid size={{ xs: 11, sm: 11 }} display={"flex"} alignSelf={"center"} padding={1}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{dadosPropostaFranquia2.nome}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP GASTO: ${formatNumber.format(dadosPropostaFranquia2.caP_Gasto)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP DISPONÍVEL: ${formatNumber.format(dadosPropostaFranquia2.caP_Disponivel)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`SLOT DISPONÍVEL: ${dadosPropostaFranquia2.slot_Disponivel} `}</Typography>
                                        </Grid>
                                        <Box sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: themeName === "light" ? "black" : "auto",
                                            }
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                autoHeight
                                                columnHeaderHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                getRowId={(rows) => rows.codigo_Pick}
                                                rows={lstDadosPicksF2}
                                                columns={columnsPicks}
                                                rowHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 20,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{
                                                    codigo: false,
                                                    codigo_Tipo_Ativo: false,
                                                }}
                                                pageSizeOptions={[20]}
                                                disableRowSelectionOnClick
                                                disableVirtualization
                                                checkboxSelection
                                                disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                disableColumnMenu={true}
                                                onRowSelectionModelChange={(ids) => {
                                                    handleRowsSelectionPicksF2(ids, 4, 2);

                                                }}
                                                //isRowSelectable={(params: GridRowParams) => params.row.status < 5}
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </>)}
                            <Grid size={{ xs: 12, sm: 12 }} >
                                {!removeLoading && <Loading />}
                            </Grid>
                            {lstDadosMultasF1.length > 0 && lstDadosMultasF2.length > 0 && (<>
                                <Grid size={{ xs: 12, sm: 12 }} >
                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Troca Multas</Typography>
                                    <hr />
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Grid container size={{ xs: 12, sm: 12 }} display={"flex"} alignSelf={"center"} gap={1}>
                                        <Grid size={{ xs: 1, sm: 1 }} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                            <img src={dadosPropostaFranquia1.logo != null ? dadosPropostaFranquia1.logo : "../../semimagemescudo.png"} alt={dadosPropostaFranquia1.nome} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />
                                        </Grid>
                                        <Grid size={{ xs: 11, sm: 11 }} display={"flex"} alignSelf={"center"} padding={1}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{dadosPropostaFranquia1.nome}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP GASTO: ${formatNumber.format(dadosPropostaFranquia1.caP_Gasto)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP DISPONÍVEL: ${formatNumber.format(dadosPropostaFranquia1.caP_Disponivel)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`SLOT DISPONÍVEL: ${dadosPropostaFranquia1.slot_Disponivel} `}</Typography>
                                        </Grid>
                                        <Box sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: themeName === "light" ? "black" : "auto",
                                            }
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                autoHeight
                                                columnHeaderHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                getRowId={(rows) => rows.codigo_Multa}
                                                rows={lstDadosMultasF1}
                                                columns={columnsMulta}
                                                rowHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 20,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{
                                                    codigo: false,
                                                    codigo_Tipo_Ativo: false,
                                                }}
                                                pageSizeOptions={[20]}
                                                disableRowSelectionOnClick
                                                disableVirtualization
                                                checkboxSelection
                                                disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                disableColumnMenu={true}
                                                onRowSelectionModelChange={(ids) => {
                                                    handleRowsSelectionMultaF1(ids, 3, 1);

                                                }}
                                                // isRowSelectable={(params: GridRowParams) => params.row.status < 5}
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Grid container size={{ xs: 12, sm: 12 }} display={"flex"} alignSelf={"center"} gap={1}>
                                        <Grid size={{ xs: 1, sm: 1 }} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                            <img src={dadosPropostaFranquia2.logo != null ? dadosPropostaFranquia2.logo : "../../semimagemescudo.png"} alt={dadosPropostaFranquia2.nome} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />
                                        </Grid>
                                        <Grid size={{ xs: 11, sm: 11 }} display={"flex"} alignSelf={"center"} padding={1}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{dadosPropostaFranquia2.nome}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP GASTO: ${formatNumber.format(dadosPropostaFranquia2.caP_Gasto)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`CAP DISPONÍVEL: ${formatNumber.format(dadosPropostaFranquia2.caP_Disponivel)} `}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} padding={0} gap={0}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{`SLOT DISPONÍVEL: ${dadosPropostaFranquia2.slot_Disponivel} `}</Typography>
                                        </Grid>

                                        <Box sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: themeName === "light" ? "black" : "auto",
                                            }
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                autoHeight
                                                columnHeaderHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                getRowId={(rows) => rows.codigo_Multa}
                                                rows={lstDadosMultasF2}
                                                columns={columnsMulta}
                                                rowHeight={UtilidadeService.isMobile() ? 38 : 48}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 20,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{
                                                    codigo: false,
                                                    codigo_Tipo_Ativo: false,
                                                }}
                                                pageSizeOptions={[20]}
                                                disableRowSelectionOnClick
                                                disableVirtualization                                                
                                                checkboxSelection
                                                disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                disableColumnMenu={true}
                                                onRowSelectionModelChange={(ids) => {
                                                    handleRowsSelectionMultaF2(ids, 3, 2);

                                                }}
                                                // isRowSelectable={(params: GridRowParams) => params.row.status < 5}
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </>)}
                            {(lstDadosJogadoresF1.length > 0 || lstDadosMultasF1.length > 0 || lstDadosPicksF1.length > 0) && (
                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} marginTop={2} >
                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} marginTop={2} display="flex" alignItems="center" justifyContent="center" justifyItems="center" textAlign="end">
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            disableElevation
                                            type="submit"
                                            endIcon={<Icon>cash</Icon>}>
                                            GERAR SOLICITAÇÃO
                                        </Button>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    )
};

